import { MediaIncludes } from '../utils/includes';
import type { Schemas } from '@shopware/api-client/api-types';

export function useGetMedia() {
    const { apiClient } = useShopwareContext();

    const getMedia = async (mediaIds: string[] | undefined) => {
        if (!mediaIds?.length) {
            return { data: null };
        }

        return useAsyncData(`media-${mediaIds.join('|')}`, async () => {
            try {
                return (
                    await apiClient.invoke('getMedia post /media', {
                        body: {
                            ids: mediaIds,
                            limit: mediaIds.length,
                            includes: {
                                media: MediaIncludes,
                            },
                        },
                    })
                ).data;
            } catch (error) {
                return null;
            }
        });
    };

    const getSpecificMedia = (mediaId: string | undefined, medias: Schemas['Media'][] | null) => {
        if (!mediaId) return null;
        return medias?.find((media: Schemas['Media']) => media.id === mediaId);
    };

    return {
        getMedia,
        getSpecificMedia,
    };
}
